import React from 'react'
import 'normalize.css/normalize.css'
import '../styles/sass/main.scss'

import Header from './layout/header.component'
import Footer from './layout/footer.component'

// Component when the app is working normally (not in maintenance mode)
import Account from './account/account.component'

// Maintenance mode component. Don't open it unless the app is in maintenance mode
//import MaintenanceComponent from './account/maintenanceMode.component'

import Login from './account/login.component'
import Register from '../containers/register.container'
import Callback from '../containers/callback.container'
import Invoice from '../containers/invoice/invoice.container'
import Salary from '../containers/salary/salary.container'
import Customer from '../containers/customer/customer.container'
import InvoiceReview from '../containers/invoice/invoiceReview.container'
import Dashboard from '../containers/dashboard/dashboard.container'
import Profile from '../containers/profile/profile.container'
import Tax from '../containers/profile/tax.container'
import Expenses from '../containers/expenses/expenses.container'
import NewExpense from '../containers/expenses/newExpense.container'
import NewAllowance from '../containers/expenses/newAllowance.container'
import Admin from '../containers/admin/admin.container'
import OpenForWork from '../containers/openforwork/openforwork.container'
import Assignments from '../containers/openforwork/assignments.container'
import Applications from '../containers/openforwork/applications.container'
import WorkshiftNormalUser from '../containers/openforwork/workshiftNormalUser.container'
import Welcome from './account/welcome.component'
import { Route, Switch } from 'react-router-dom'
import { PrivateRoute } from '../routes'
import SideNavigation from './layout/sideNavigation.component'

/**
 * The main component for handling user authentication requests.
 *
 * @author Pragya Gupta
 */

const Main = ({
  user,
  navItems,
  path,
  handleManualLogout,
  showNotiDialog,
  getUserCompanyUpdateInfo,
  openCompanyNotificationDialog,
  closeCompanyNotificationDialog,
  notiIsNotRead,
  setReadCompanyUpdate,
  userTaxInfo,
  lang,
  updateUserEmailSuccess
}) => {
  // Calling getCompanyUpdates so user can see the notification without the effection of location changes
  React.useEffect(() => {
    if (Object.keys(userTaxInfo).length === 0) {
      getUserCompanyUpdateInfo()
    }
  }, [userTaxInfo])
  // Force log out after user email changed
  React.useEffect(() => {
    if (updateUserEmailSuccess && path !== '/dashboard/profile') {
      handleLogout()
    }
  }, [updateUserEmailSuccess, path])

  const renderSideNavigation = user

  const isDesktop = window.innerWidth >= 768

  return (
    <div>
      <Header
        user={user}
        navItems={navItems}
        handleManualLogout={handleManualLogout}
        showNotiDialog={showNotiDialog}
        getUserCompanyUpdateInfo={getUserCompanyUpdateInfo}
        openCompanyNotificationDialog={openCompanyNotificationDialog}
        closeCompanyNotificationDialog={closeCompanyNotificationDialog}
        notiIsNotRead={notiIsNotRead}
        setReadCompanyUpdate={setReadCompanyUpdate}
      />
      <div
        className={renderSideNavigation && isDesktop ? 'layout-container' : ''}
      >
        {renderSideNavigation && (
          <SideNavigation user={user} navItems={navItems} />
        )}
        <div
          style={{
            marginBottom: '50px'
          }}
        >
          <Switch>
            <Route path="/dashboard/login">
              <Login />
            </Route>
            <Route path="/dashboard/register">
              <Register />
            </Route>
            <Route path="/kiitos-rekisteroitymisesta">
              <Welcome />
            </Route>
            <Route path="/dashboard/callback">
              <Callback />
            </Route>
            <PrivateRoute path="/dashboard/main">
              <Dashboard />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/invoice/review">
              <InvoiceReview />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/invoice">
              <Invoice />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/salary">
              <Salary />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/customer">
              <Customer />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/tax">
              <Tax />
            </PrivateRoute>
            <PrivateRoute exact path="/dashboard/profile">
              <Profile />
            </PrivateRoute>
            <PrivateRoute exact path="/dashboard/profile/openforwork">
              <OpenForWork />
            </PrivateRoute>
            <PrivateRoute exact path="/dashboard/fee">
              <Expenses />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/fee/newfee">
              <NewExpense />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/fee/newallowance">
              <NewAllowance />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/admin">
              <Admin />
            </PrivateRoute>
            {/* <PrivateRoute exact path="/dashboard/openforwork">
          <OpenForWork />
        </PrivateRoute> */}
            <PrivateRoute path="/dashboard/openforwork/assignments">
              <Assignments />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/openforwork/applications">
              <Applications />
            </PrivateRoute>
            <PrivateRoute path="/dashboard/openforwork/workshifts">
              <WorkshiftNormalUser />
            </PrivateRoute>
          </Switch>
        </div>
      </div>
      {/*Component when the app is working normally (not in maintenance mode)*/}
      {!user &&
        path !== '/dashboard/register' &&
        path !== '/dashboard/login' && <Account />}

      {/*Maintenance mode component. Don't open it unless the app is in maintenance mode*/}
      {/*       {!user &&
        path !== '/dashboard/register' &&
        path !== '/dashboard/login' && <MaintenanceComponent />} */}
      {/*end*/}
      <Footer lang={lang} />
    </div>
  )
}

const handleLogout = () => {
  sessionStorage.clear()
  window.location.href = '/dashboard/login' // Redirect to login page
}

export default Main
